import { GlobalStyles } from '@mui/material';
import { Sidetab } from '@typeform/embed-react';
import { useAuth } from '../../core/authContext';
import { FEEDBACK_PERCENT, inFeedbackSample } from './feedbackSample';

const IFRAME_PROPS = { title: 'Student Progress Reports Feedback', referrerpolicy: 'no-referrer' };
const PRINT_STYLES = { '@media print': { '.tf-v1-sidetab': { display: 'none !important' } } };

export function FeedbackSidetab() {
  const formId: string | undefined = import.meta.env.REACT_APP_PROGRESS_REPORTS_FEEDBACK_FORM_ID;
  const { user } = useAuth();
  if (!formId || !user?.id || !inFeedbackSample(formId, user.id, FEEDBACK_PERCENT)) return null;
  return (
    <>
      <GlobalStyles styles={PRINT_STYLES} />
      <Sidetab
        id={formId}
        buttonText="Share feedback"
        buttonColor="#FA6B05"
        open="time"
        openValue={3000}
        autoClose
        preventReopenOnClose
        iframeProps={IFRAME_PROPS}
        hidden={{ user_id: user.id }}
      />
    </>
  );
}
